import React from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import Paragraph from './Paragraph';
import './style.scss';


const ParagraphMultipleParagraphs = ({ entity, className }) => {
  const classes = classNames('Paragraph ParagraphMultipleParagraphs', className);

  return (
    <div className={classes}>
      <Container>
        <div className="ParagraphMultipleParagraphs__paragraphs row">
          {entity.get('field_paragraphs', List()).map((paragraph, i) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div className="col-md-6" key={`paragraph:${id}:${language}`}>
                <Paragraph
                  entity={paragraph.get('entity')}
                  className={classNames({ 'is-first': i === 0 })}
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default ParagraphMultipleParagraphs;
